import { useToast } from '~/composables/useToast'

export const useManufacturingStatusAlerts = (isAuthorized: Ref<boolean>) => {
  const supabase = useSupabaseClient()
  const { showToast } = useToast()
  const { play } = useAlertSound('atelier-manufacturing-sound-enabled')
  let channel: ReturnType<typeof supabase.channel> | null = null
  let reconnectTimer: ReturnType<typeof setTimeout> | null = null
  const subscribe = async () => {
    if (typeof window === 'undefined' || channel || !isAuthorized.value) return
    const { data } = await supabase.auth.getSession()
    if (!data.session?.access_token) return
    supabase.realtime.setAuth(data.session.access_token)
    channel = supabase.channel(`atelier-manufacturing-${Date.now()}`).on('postgres_changes', { event: 'UPDATE', schema: 'public', table: 'manufacturing_orders' }, (payload) => {
      const next: any = payload.new; const previous: any = payload.old
      if (!next || next.status === previous?.status) return
      showToast({ type: 'info', title: 'Fabrication mise à jour', message: `${next.name || 'Ordre'} · ${next.status}`, duration: 6000 })
      void play()
    }).subscribe((state) => {
      if ((state === 'CHANNEL_ERROR' || state === 'TIMED_OUT') && !reconnectTimer) reconnectTimer = setTimeout(() => { reconnectTimer = null; unsubscribe(); void subscribe() }, 3000)
    })
  }
  const unsubscribe = () => { if (channel) supabase.removeChannel(channel); channel = null }
  watch(isAuthorized, value => value ? void subscribe() : unsubscribe(), { immediate: true })
  onBeforeUnmount(() => { if (reconnectTimer) clearTimeout(reconnectTimer); unsubscribe() })
}
